module.exports = __webpack_public_path__ + "static/media/kickoff.cb92ca2b.svg";